import React from "react";
import { NavLink, useNavigate } from "react-router";
import { FileText, HelpCircle, LogOut, Settings, User } from "lucide-react";
import { classNames } from "../../lib/format";
import { FooterPanel } from "./FooterPanel";
import SystemStatus from "../ui/SystemStatus";

type NavItem = {
  to: string;
  label: string;
  icon: React.ElementType;
};

const NAV_ITEMS: NavItem[] = [
  { to: "/amministrazione/contabilita", label: "Contabilità", icon: FileText },
  { to: "/account", label: "Account", icon: User },
  // { to: "/amministrazione/files", label: "File caricati", icon: FolderOpen },
];

const BOTTOM_NAV_ITEMS: NavItem[] = [
  { to: "/manuale", label: "Manuale", icon: HelpCircle },
  { to: "/manuale-tecnico", label: "Manuale tecnico", icon: Settings },
];

export function Sidenav() {
  const navigate = useNavigate();

  const onLogout = () => {
    try {
      localStorage.removeItem("auth_token");
    } catch {}
    navigate("/login", { replace: true });
  };

  return (
    <aside
      className="fixed inset-y-0 left-0 w-72 bg-slate-950/80 backdrop-blur-md
                 border-r border-white/10 flex flex-col z-40"
    >
      {/* Header (logo) */}
      <div className="flex items-center gap-3 px-5 py-4 border-b border-white/5">
        <div className="flex flex-col leading-tight">
          <img
            src="/logo.png"
            alt="Italpreziosi"
            className="h-8 w-auto object-contain"
          />
          <span className="text-[0.65rem] uppercase tracking-[0.15em] text-slate-200/70 mt-1">
            Data Platform
          </span>
        </div>
      </div>

      {/* Navigazione scrollabile */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                classNames(
                  "flex items-center gap-2 rounded-lg px-3 py-3 my-2 text-sm transition-all",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40",
                  isActive
                    ? "bg-white/90 text-slate-900 shadow-sm"
                    : "text-slate-100/80 hover:bg-white/5 hover:text-white"
                )
              }
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* System status (resta com'è) */}
      <SystemStatus />

      {/* Bottom nav (Manuale, ecc.) */}
      <div className="px-3 pb-1 border-t border-white/5 pt-2 space-y-1">
        {BOTTOM_NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                classNames(
                  "flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-all",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40",
                  isActive
                    ? "bg-white/90 text-slate-900 shadow-sm"
                    : "text-slate-100/80 hover:bg-white/5 hover:text-white"
                )
              }
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </div>

      {/* Footer azioni */}
      <div className="px-3 pb-3 pt-2 border-t border-white/5">
        <button
          type="button"
          onClick={onLogout}
          className="group w-full inline-flex items-center justify-center gap-2
                     rounded-lg border border-white/10 bg-white/5 px-3 py-2
                     text-sm font-medium text-slate-100/90
                     transition
                     hover:bg-white/10 hover:border-white/20 hover:text-white
                     focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
          title="Esci dall'account"
          aria-label="Logout"
        >
          <LogOut className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
          <span className="tracking-tight">Logout</span>
        </button>

        {/* Mini hint secondario, molto discreto (opzionale) */}
        {/* <p className="mt-2 text-[10px] text-slate-300/60 text-center">
          Accedi di nuovo per cambiare utente
        </p> */}
      </div>

      <FooterPanel />
    </aside>
  );
}
